function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 11.132l-.877-.863c-4.089-4.025-10.726-4.025-14.815 0a10.157 10.157 0 000 14.53L24 40.245l15.692-15.448a10.157 10.157 0 000-14.53c-4.09-4.024-10.726-4.024-14.815 0l-.877.864zM24 42L7.431 25.689a11.407 11.407 0 010-16.31c4.576-4.505 11.994-4.505 16.569 0 4.575-4.505 11.993-4.505 16.569 0a11.407 11.407 0 010 16.31L24 42z",
  fill: "currentColor"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgICBkPSJtMjQgMTEuMTMyLS44NzctLjg2M2MtNC4wODktNC4wMjUtMTAuNzI2LTQuMDI1LTE0LjgxNSAwYTEwLjE1NyAxMC4xNTcgMCAwIDAgMCAxNC41M0wyNCA0MC4yNDVsMTUuNjkyLTE1LjQ0OGExMC4xNTcgMTAuMTU3IDAgMCAwIDAtMTQuNTNjLTQuMDktNC4wMjQtMTAuNzI2LTQuMDI0LTE0LjgxNSAwbC0uODc3Ljg2NFpNMjQgNDIgNy40MzEgMjUuNjg5YTExLjQwNyAxMS40MDcgMCAwIDEgMC0xNi4zMWM0LjU3Ni00LjUwNSAxMS45OTQtNC41MDUgMTYuNTY5IDAgNC41NzUtNC41MDUgMTEuOTkzLTQuNTA1IDE2LjU2OSAwYTExLjQwNyAxMS40MDcgMCAwIDEgMCAxNi4zMUwyNCA0MloiCiAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4=";
export { SvgHeart as ReactComponent };